import { render, staticRenderFns } from "./Automotriz.vue?vue&type=template&id=28376e38&"
import script from "./Automotriz.vue?vue&type=script&lang=js&"
export * from "./Automotriz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports